export enum EtatLogementFoyer {
  NonNenseigne = "non_renseigne",
  LogementRehabilite = "logement_rehabilite",
  LogementNonRehabilite = "logement_non_rehabilite",
}

export enum LocationCategory {
  Vide = "vide",
  Meuble = "meuble",
  Foyer = "foyer",
}

export enum LogementCategory {
  Proprietaire = "proprietaire",
  Locataire = "locataire",
  Heberge = "heberge",
  SansDomicile = "sansDomicile",
}

export enum StatutOccupationLogement {
  PrimoAccedant = "primo_accedant",
  Proprietaire = "proprietaire",
  LocataireVide = "locataire_vide",
  LocataireMeuble = "locataire_meuble",
  LogeGratuitement = "loge_gratuitement",
  LocataireFoyer = "locataire_foyer",
  SansDomicile = "sans_domicile",
}
